export default "__VITE_ASSET__DVseyS0Q__"